import type { ReactNode } from 'react'

interface ConfirmModalProps {
  isOpen: boolean
  title: string
  message?: string
  children?: ReactNode
  confirmText: string
  cancelText: string
  onConfirm: () => void
  onCancel: () => void
  variant?: 'primary' | 'danger'
}

function ConfirmModal({
  isOpen,
  title,
  message,
  children,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  variant = 'primary'
}: ConfirmModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onCancel}
      ></div>

      {/* Dialog */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        {/* Header */}
        <h2 className="text-xl font-bold text-gray-900 mb-4">{title}</h2>

        {/* Body */}
        {message && (
          <p className="text-gray-700 mb-6 whitespace-pre-wrap">{message}</p>
        )}
        {children && (
          <div className="mb-6">{children}</div>
        )}

        {/* Footer */}
        <div className="flex gap-3">
          {cancelText && (
            <button
              onClick={onCancel}
              className="flex-1 bg-fx-reset text-white px-4 py-3 rounded-lg font-medium hover:opacity-90 transition-all"
            >
              {cancelText}
            </button>
          )}
      
          <button
            onClick={onConfirm}
            className={`flex-1 text-white px-4 py-2 rounded-md hover:opacity-90 font-medium transition-all ${
              variant === 'danger' ? 'bg-red-600 hover:bg-red-700' : 'bg-fx-confirm'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
